import client from "services/client";
import { api2 } from "controllers/api";
const getUserDetails = async (userId) => {
  const url = `/users/${userId}`;
  const response = await client.get(url);
  return response;
};

const getUserOtherAccountsDetails = async (userId) => {
  const url = `/account/getAllSecondaryAccs/${userId}`;
  const response = await api2.get(url);
  return response;
};

const generateNewUserToken = async (data) => {
  const url = `/users/login/switch`;
  const response = await client.post(url, data);
  return response;
};
export { getUserDetails, getUserOtherAccountsDetails, generateNewUserToken };
